import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 *
 * Search for salesAgents.
 * @param listMetaData {ListMetaData}
 * @returns {Promise<AxiosResponse<object[]>>}
 * @constructor
 */
const FindMany = async listMetaData => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.SALES_AGENTS,
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

const SalesAgentService = {
  FindMany
}

export default SalesAgentService
